module.exports = __webpack_public_path__ + "static/media/ttkbelleten.da5485ea.jpg";